<template>
  <v-app>
    <v-main>
      <v-container class="mt-0">
        <v-row class="d-flex justify-center">
          <v-col lg="4" md="6" sm="8" cols="10">
            <v-img
              alt="DSDA Logo"
              class="shrink mx-auto"
              contain
              src="../assets/icon.png"
              transition="scale-transition"
              height="100px"
            />
            <v-card color="primary" dark class="mt-2">
              <v-card-title >
              </v-card-title>
              <v-card-text>
                <v-row class="text-center">
                  <v-col class="mb-n6">
                    <h1 style="color:white">Log-In</h1>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                   <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      type="email"
                      prepend-icon="mdi-email"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      :rules="passwordRules"
                      label="Password"
                      :type="show1 ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      required
                    ></v-text-field>
                    <h4 style="color:#ff5252">{{errorServer}}</h4>
                    <br>
                    <v-row>
                    <v-col>
                    <v-list-item two-line class="float-start mt-n4">
                    <v-list-item-content>
                      <v-list-item-action-text>
                        <v-dialog
                          v-model="dialog"
                          max-width="500"
                        >
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            text
                            x-small
                            v-bind="attrs"
                            v-on="on"
                          >
                          Forgot Password?
                        </v-btn>
                        </template>
                        <v-card>
                          <v-toolbar color="primary" dark>
                            Change Password
                          </v-toolbar>
                          <v-card-text>
                            <v-text-field
                              v-model="emailReset"
                              :rules="emailRules"
                              label="E-mail"
                              type="email"
                              prepend-icon="mdi-email"
                              required
                            ></v-text-field>
                            <h4 style="color:#ff5252">{{errorReset}}</h4>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn
                              text
                              @click="passReset(emailReset)"
                            >Send</v-btn>
                          </v-card-actions>
                        </v-card>
                        </v-dialog>
                      </v-list-item-action-text>
                      <router-link :to="{name: 'Register'}">
                      <v-list-item-action-text>
                        <v-btn
                            text
                            x-small
                          >
                          Register
                        </v-btn>
                      </v-list-item-action-text>
                      </router-link>

                      <router-link :to="{name: 'ContactUs'}">
                      <v-list-item-action-text>
                        <v-btn
                            text
                            x-small
                          >
                          Contact Us
                        </v-btn>
                      </v-list-item-action-text>
                      </router-link>
                      
                      </v-list-item-content>

                    </v-list-item>
                    </v-col>
                    <v-col>
                    <v-btn
                      color="warning"
                      class="float-end ma-2"
                      @click="LogIn(email,password)"
                    >
                      Log In
                    </v-btn>
                    </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="text-center">
                      <v-col>
                        <router-link style="text-decoration: none; color: inherit;" :to="{name: 'Login Petugas'}">
                          <v-btn
                              color="secondary"
                              class="mt-2"
                            >
                            Log-In Petugas
                          </v-btn>
                        </router-link>
                      </v-col>
                    </v-row>
                  </v-form> 
                  <v-snackbar
                    v-model="snackbar"
                    :timeout="timeout"
                    centered
                    color="warning"
                    dark
                  >
                    Password Reset Email is Sent!
                  </v-snackbar>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-center">
          <v-col>
            <v-card flat class="my-4">
              <v-row no-gutters class="text-center">
                <v-col>
                  <v-img
                    alt="Dinas Logo"
                    class="shrink float-left"
                    contain
                    src="@/assets/provinsi.png"
                    transition="scale-transition"
                    width="70"
                  />
                  <div class="text-caption">DINAS SUMBER DAYA AIR PROVINSI JAWA BARAT</div>  
                  <div class="text-caption">Jl.Braga No.137, Babakan Ciamis, Kec. Sumur Bandung,</div>
                  <div class="text-caption">Kota Bandung, Jawa Barat 40111 (022) 4236113</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/auth'
import { db }from "../firebase/db.js"

  export default {
    name: 'LogIn',

    data: () => ({
      show1: false,
      snackbar:false,
      dialog: false,
      emailReset:'',
      timeout: 2000,
      email:'',
      password:'',
      errorServer:'',
      errorReset:'',
      valid: true,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >=8) || 'Password must be at least 8 characters'
      ],
    }),
    mounted () {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          //Signed In
          var uid = user.uid;
          localStorage.setItem("uid", uid);
          if (localStorage.getItem('role')!='Petugas'){
            var userRef = db.collection('user')
            userRef.doc(uid).get().then((doc) => {
              if (doc.data().confirmed !==false) {
                //Assigned
                localStorage.setItem('location',doc.data().location)
                localStorage.setItem('role',doc.data().role)
                this.$router.push('/')
              }
            })
          } else {
            let station=localStorage.getItem("device");
            this.$router.push(`/MapPetugas-id=${station}&device=${localStorage.getItem('jenis')}`)
          }
        } 
      });
    },
    methods: {
      LogIn (email,password) {
         if (this.$refs.form.validate()) {
          let loader = this.$loading.show()
           firebase.auth().signInWithEmailAndPassword(email, password)
          .then((userCredential) => {
            // Signed in
            var user = userCredential.user.uid;
            var userRef = db.collection('user')
            userRef.doc(user).get().then((doc) => {
              localStorage.setItem("uid", user);
              localStorage.setItem("role", doc.data().role);
              localStorage.setItem("location", doc.data().location);
              loader.hide()
              if (doc.data().confirmed !==false) {
                  this.$router.push('/')
              } else {
                  this.$router.push('confirm')
              }
            }).catch(()=>{
              loader.hide()
            })
          })
          .catch((error) => {
            this.errorServer = error.message;
            loader.hide()
          });
         }
      },
      passReset(email) {
        let loader = this.$loading.show()
        firebase.auth().sendPasswordResetEmail(email)
        .then(() => {
          this.dialog=false
          this.snackbar=true
          loader.hide()
        })
        .catch((error) => {
          this.errorReset=error.message
          loader.hide()
        });
      }
    },
  }
</script>
